var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8184 41.4915L54.695 68.9357C54.7496 69.2589 54.7043 69.591 54.565 69.8877C54.4258 70.1844 54.1993 70.4315 53.9158 70.596C53.6323 70.7605 53.3054 70.8345 52.9787 70.8082C52.652 70.7818 52.3412 70.6564 52.0877 70.4486L40.5641 61.7994C40.0078 61.3838 39.332 61.1593 38.6376 61.1593C37.9432 61.1593 37.2674 61.3838 36.7111 61.7994L25.1681 70.4454C24.9149 70.6528 24.6044 70.778 24.2781 70.8044C23.9518 70.8308 23.6252 70.757 23.3419 70.593C23.0586 70.429 22.8321 70.1825 22.6925 69.8864C22.553 69.5902 22.507 69.2586 22.5608 68.9357L27.4342 41.4915",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6267 45.0644C49.2932 45.0644 57.94 36.4175 57.94 25.7511C57.94 15.0846 49.2932 6.43774 38.6267 6.43774C27.9602 6.43774 19.3134 15.0846 19.3134 25.7511C19.3134 36.4175 27.9602 45.0644 38.6267 45.0644Z",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeicon);
export default __webpack_public_path__ + "static/media/badge icon.897de26dd8b6cc0c2280f45cdc88ebbe.svg";
export { ForwardRef as ReactComponent };